import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUser } from './userContext';
import useCheckLogin from './CustomHooks/useCheckLogin';
const ProtectedRoute = ({ children }) => {
  const isLoading = useCheckLogin(); 
  const { user } = useUser(); 

  if (isLoading) {
    return <div>Ładowanie...</div>; 
  }
  if (!user) {
    return <Navigate to="/login" replace/>; 
  }

  return children;
};

export default ProtectedRoute;
